/* unplugin-vue-components disabled */import { render } from "./KnotQuestionView.vue?vue&type=template&id=0924a90d&scoped=true"
import script from "./KnotQuestionView.vue?vue&type=script&lang=js"
export * from "./KnotQuestionView.vue?vue&type=script&lang=js"

import "./KnotQuestionView.vue?vue&type=style&index=0&id=0924a90d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0924a90d"]])

export default __exports__